import React from "react";
import PropTypes from 'prop-types';

const LinkedInConsent = ({ formik, isRestricted }) => {
    return (
        <div className="linkedin-consent p-2 mt-3">
            <div className="consent-input">
                <input
                    name="Updated Consent"
                    type="checkbox"
                    id="consent"
                    className="mr-2 special"
                    onChange={e => {
                        if (e.target.checked) {
                            formik.setFieldValue("consent", true);
                        } else {
                            formik.setFieldValue("consent", false);
                        }
                    }}
                    disabled={isRestricted}
                />
                <label htmlFor="consent" className="consent_text">
                    {" "}
                    I have updated the Redirect URL in my LinkedIn app settings with the URL provided by the platform.
                </label>
                <br />
                <div><strong>Note:</strong> This step is essential to ensure the automatic LinkedIn post feature works correctly.</div>
            </div>
            <div className="consent-input mt-3">
                <input
                    name="Updated Consent"
                    type="checkbox"
                    id="app-permission-consent"
                    className="mr-2 special"
                    onChange={e => {
                        if (e.target.checked) {
                            formik.setFieldValue("appPermissionConsent", true);
                        } else {
                            formik.setFieldValue("appPermissionConsent", false);
                        }
                    }}
                    disabled={isRestricted}
                />
                <label htmlFor="app-permission-consent" className="consent_text">
                    {" "}
                    I have Requested Access for both <strong>Share on LinkedIn</strong> and <strong>Sign In with LinkedIn using OpenID Connect</strong> Products.
                </label>
                <br />
                <div><strong>Note:</strong> This step is essential to defined OAuth 2.0 Scopes for ensuring what your app can do on a user’s behalf.</div>
            </div>
        </div>
    );
};

LinkedInConsent.propTypes = {
    formik: PropTypes.object.isRequired,
    isRestricted: PropTypes.bool
};

export default LinkedInConsent;